import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { closeServiceAdditionalPopup } from 'pages/Internet/store/actions';
import { getFTTBAdditionalPopupNoMoney } from 'pages/Internet/store/selectors/servicesSelectors';
import { PopupButton, PopupButtonLink, PopupText } from '../../../../components';

export const NoMoneyText = compose(connect(
  (state) => ({
    children: getFTTBAdditionalPopupNoMoney(state).text, // connectionNoMoneyResponse.texts.text,
    shouldRender: !!getFTTBAdditionalPopupNoMoney(state).text,
  }),
), withRenderFlag)(PopupText);
export const NoMoneyTitle = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupNoMoney(state).title,
      shouldRender: !!getFTTBAdditionalPopupNoMoney(state).title,
      isTitle: true,
    }),
  ), withRenderFlag,
)(PopupText);
export const NoMoneyPaymentRequestButtonLink = compose(
  connect(
    (state) => ({
      url: getFTTBAdditionalPopupNoMoney(state).toPaymentMethodsBtn?.link,
      children: getFTTBAdditionalPopupNoMoney(state).toPaymentMethodsBtn?.text,
      shouldRender: !!getFTTBAdditionalPopupNoMoney(state).toPaymentMethodsBtn?.text,
    }), {
      onClick: closeServiceAdditionalPopup,
    },
  ), withRenderFlag,
)(PopupButton);

export const NoMoneyGoBackButtonLink = compose(
  connect(
    (state) => ({
      url: getFTTBAdditionalPopupNoMoney(state).comeBackBtn?.link,
      children: getFTTBAdditionalPopupNoMoney(state).comeBackBtn?.text,
      shouldRender: !!getFTTBAdditionalPopupNoMoney(state).comeBackBtn?.text,
    }),
    {
      onClick: closeServiceAdditionalPopup,
    },
  ), withRenderFlag,
)(PopupButtonLink);
